var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7089 13.3326H13.9847L13.7281 13.0848C14.8281 11.7996 15.3964 10.0463 15.0847 8.1828C14.6539 5.63085 12.5272 3.59296 9.96057 3.28085C6.08307 2.8035 2.81974 6.07147 3.29641 9.95448C3.60807 12.5248 5.64307 14.6545 8.19141 15.0859C10.0522 15.398 11.8031 14.8289 13.0864 13.7273L13.3339 13.9844V14.7096L17.2297 18.6109C17.6056 18.9873 18.2197 18.9873 18.5956 18.6109C18.9714 18.2346 18.9714 17.6195 18.5956 17.2431L14.7089 13.3326ZM9.20891 13.3326C6.92641 13.3326 5.08391 11.4875 5.08391 9.20174C5.08391 6.916 6.92641 5.07089 9.20891 5.07089C11.4914 5.07089 13.3339 6.916 13.3339 9.20174C13.3339 11.4875 11.4914 13.3326 9.20891 13.3326Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.5c65ce93496eca010eed9ccedbc82142.svg";
export { ForwardRef as ReactComponent };